import React from "react";
import { useSelector } from "react-redux";
import { cashConverter } from "../../../utils";

function WithdrawalCard() {
   const url = "api/v1/commissions/fetch-commission-dashboard";
 const { data, count } = useSelector((state) => ({
   data: state.fetch.data[url] || [],
   count: state.fetch.count[url] || 0,
 }));
  return (
    <div className="bg-[#F4F3F3] rounded-[1rem] p-[2.25rem] flex justify-between mt-[1.25rem]">
      <div className="flex flex-col">
        <span className="text-[#706F6F] text-[1rem] font-[400]">
          Payment REF
        </span>
        <span className="text-[#0E0E0E] font-[500] text-[1.25rem]">YRBKMK</span>
      </div>

      <div className="flex flex-col">
        <span className="text-[#706F6F] text-[1rem] font-[400]">
          Total Bill
        </span>
        <span className="text-[#0E0E0E] font-[500] text-[1.25rem]">
        {cashConverter(data?.statusSummary?.Commissioned)}
        </span>
      </div>
    </div>
  );
}

export default WithdrawalCard;
